// extracted by mini-css-extract-plugin
export default {"candidatesHeader":"CandidatesHeader_candidatesHeader__Rq4z9","candidate":"CandidatesHeader_candidate__MMrkp"};